import { InputSelect, InputSelectProps } from "components/Atomos/Form/Elements/InputSelect"
import { streetTypes } from "components/Moleculas/StreetTypeField/types"
import { FieldValues } from "react-hook-form"

type StreetTypeSelectProps<T extends FieldValues> = Omit<InputSelectProps<T>, 'option'> & {

}

const StreetTypeSelect = <T extends FieldValues>({
    ...rest
}: StreetTypeSelectProps<T>) => {
    return (
        <InputSelect
            {...rest}
            option={streetTypes.map(item => ({
                value: item.nome,
                label: item.nome,
            }))}
        />
    )
}
export default StreetTypeSelect